import { useState, MouseEventHandler } from "react";
import { useSelectTheme } from "../../store";
import { RIF, _ } from "../../lib";
import {
  NotificationDefaultIcon,
  NotificationActivatedIcon,
  NotificationWarningDefaultIcon,
  NotificationWarningActivatedIcon,
} from "../../asset/image";

export interface NotificationButtonPropsT {
  enable: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
  index?: number;
}

export const NotificationButton = (props: NotificationButtonPropsT) => {
  const { fontWeight, color } = useSelectTheme();
  const [tipPop, setTipPop] = useState(false);
  const { enable, index, ...rest } = props;
  const handleOver = _.debounce(() => {
    setTipPop(true);
  }, 100);
  const handleOut = _.debounce(() => {
    setTipPop(false);
  }, 100);

  return (
    <button
      type="button"
      {...rest}
      onMouseEnter={handleOver}
      onMouseLeave={handleOut}
      aria-label="Send notification to this participant"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        zIndex: 1,
        position: "relative",
        border: "none",
        background: "transparent",
        padding: 0,
      }}
    >
      {RIF(
        !tipPop,
        <img
          src={enable ? NotificationDefaultIcon : NotificationWarningDefaultIcon}
          width="20"
          alt=""
          aria-hidden
        />,
      )}
      {RIF(
        tipPop,
        <img
          src={enable ? NotificationActivatedIcon : NotificationWarningActivatedIcon}
          width="20"
          alt=""
          aria-hidden
        />,
      )}
      {RIF(
        tipPop,
        <div
          css={{
            width: "max-content",
            background: "rgba(0, 0, 0, 0.88)",
            color: color.white,
            borderRadius: "5px",
            fontWeight: fontWeight.bold,
            padding: "10px 8px",
            textAlign: "start",
            position: "absolute",
            top: index === 0 ? "130%" : "-230%",
            right: "50%",
            transform: "translateX(50%)",
            zIndex: 99,
            ":after": {
              position: "absolute",
              top: index !== 0 ? "38px" : "-8px",
              right: "50%",
              transform: "translateX(50%)",
              content: '""',
              borderTop: index !== 0 ? "10px solid rgba(0, 0, 0, 0.88)" : "",
              borderBottom: index !== 0 ? "" : "10px solid rgba(0, 0, 0, 0.88)",
              borderRight: "5px solid transparent",
              borderLeft: "5px solid transparent",
            },
          }}
        >
          Send Message
        </div>,
      )}
    </button>
  );
};
